import { AuditLog } from "@common/types/auditLog";
import React from "react";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogMemoContent: React.FC<Props> = ({ log }) => {
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );
    const oldNotes = log.diff.find((d) => d.field === "memo")?.before?.value;
    const newNotes = log.diff.find((d) => d.field === "memo")?.after?.value;

    if (oldNotes === newNotes) {
        return null;
    }

    return (
        <>
            <strong>{authorComponent}</strong> changed the memo from{" "}
            <strong>{oldNotes}</strong> to <strong>{newNotes}</strong>.
        </>
    );
};
